import styled from 'styled-components'

export const NormalizationStyled = styled.div`
    /* padding: 16px; */
    .threshold-settings-input-ruleblock {
        display: flex;
        flex-direction: row;
        flex-wrap: nowrap;
        justify-content: center;
        margin-bottom: 20px;
        margin-left: 15px;
        width: 35%;
    }

    .threshold-settings-input-newruleline {
        border-bottom: 1px solid #c8ccd4;
        margin-bottom: 8px;
        margin-left: 10px;
        margin-right: 10px;
        width: 40%;
    }

    .threshold-settings-input-button {
        width: 100px;
        color: ${({ theme }) => theme['blue-700']};
        font-size: 13px;
        /* line-height: 16px; */
        cursor: pointer;
    }

    .display-flex {
        display: flex;

        .extra-padding {
            padding: 7px;
        }
    }

    .threshold-settings-input-pfd {
        margin-top: 2px;
        width: 80px;
        .disabled-color {
            background: var(--gray-200) !important;
            background-color: var(--gray-200) !important;
            color: var(--gray-700) !important;
        }
        background: transparent;
    }

    .threshold-settings-input-gray-disabled {
        background: transparent;
        color: ${({ theme }) => theme['gray-800']};
        &.custom-width-and-margin {
            width: 120px;
            margin-top: 8px;
        }
    }

    .input-equals-string {
        color: ${({ theme }) => theme['gray-900']};
        /* color: red; */
        font-weight: ${({ theme }) => theme['font-bold']};
        font-size: 12px;
        /* margin-top: 20px; */
        padding: 16px;
        padding-top: 35px;
    }

    .default-width {
        width: 33%;
    }

    .threshold-settings-input-delete-button {
        display: flex;
        justify-content: center;
        align-items: center;
        color: var(--red-700);
        cursor: pointer;
        font-size: 16px;
        line-height: 16px;
    }

    .normalization-list {
        display: flex;
        align-items: stretch;
        flex-direction: column;
        padding: 16px;

        .normalization-list-header {
            display: grid;
            grid-template-areas: 'MIN MAX EQU PFD';
            grid-template-columns: 120px 120px 15px 120px;
            gap: 16px;
            font-size: 13px;
            line-height: 16px;
            font-family: var(--font-semibold);
            margin-bottom: 4px;
        }
        .normalization-content {
            display: flex;
            flex-direction: column;
            gap: 18px;
            .box-threshold {
                display: grid;
                grid-template-areas: 'MIN MAX EQU PFD';
                grid-template-columns: 120px 120px 15px 120px;
                gap: 16px;

                &.editing {
                    grid-template-areas: 'MIN MAX EQU PFD DEL';
                    grid-template-columns: 120px 120px 15px 120px 14px;
                }
                > input {
                    margin: 0;
                }
                .box-threshold-item {
                    &.equals {
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        font-size: 12px;
                        line-height: 16px;
                    }
                }
            }
        }
    }
`
